import { RouterView, type RouteRecordRaw } from "vue-router";
import { ROUTE_NAME } from "@/shared/constants/routes";
import { h } from "vue";

export const routes: RouteRecordRaw[] = [
  {
    path: "/organizations",
    name: ROUTE_NAME.ORGANIZATIONS,
    component: { render: () => h(RouterView) },
    redirect: { name: ROUTE_NAME.ORGANIZATION_LIST },
    children: [
      {
        path: "",
        name: ROUTE_NAME.ORGANIZATION_LIST,
        component: () => import("./views/OrganizationList.vue"),
      },
      {
        path: ":id",
        name: ROUTE_NAME.ORGANIZATION_UPDATE,
        component: () => import("./views/OrganizationUpdate.vue"),
      },
      {
        path: "create",
        name: ROUTE_NAME.ORGANIZATION_CREATE,
        component: () => import("./views/OrganizationCreate.vue"),
      },

      {
        path: ":id/teams/:teamId",
        name: ROUTE_NAME.TEAM_UPDATE,
        component: () => import("../teams/views/TeamsUpdate.vue"),
      },
      {
        path: ":id/teams/create",
        name: ROUTE_NAME.TEAM_CREATE,
        component: () => import("../teams/views/TeamsCreate.vue"),
      },
    ],
  },
];
